export default "__VITE_ASSET__CU2P30sN__"